import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { type WellBeingCategory } from '../../categories';

interface WellBeingCardProps {
  category: WellBeingCategory;
}

export const WellBeingCard = ({ category }: WellBeingCardProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);
  const navigate = useNavigate();

  const handleButtonClick = (): void => {
    if (category.isAvailable) {
      navigate(category.route);
    }
  };

  return (
    <div className="w-full max-w-sm mx-auto">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-6 h-6 shrink-0 ">
          <category.icon className="w-full h-full text-teal-600" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900">{t(category.titleKey)}</h3>
      </div>
      <div className="relative overflow-hidden rounded-lg shadow-lg bg-white">
        <div className="relative overflow-hidden">
          <img
            src={category.image}
            alt={t(category.titleKey)}
            className="w-full h-full object-contain"
          />
        </div>
        <div className="p-6">
          <p className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-2">
            {t(category.descriptionKey)}
          </p>
          <Button className="w-full" onClick={handleButtonClick} disabled={!category.isAvailable}>
            {category.isAvailable ? t(category.buttonKey) : t('WellBeing.notAvailable')}
          </Button>
        </div>
      </div>
    </div>
  );
};
